import { render } from "./editProduct.vue?vue&type=template&id=6912d6a0"
import script from "./editProduct.vue?vue&type=script&lang=js"
export * from "./editProduct.vue?vue&type=script&lang=js"

import "./editProduct.vue?vue&type=style&index=0&id=6912d6a0&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__